var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vfl-has-label"},[_c('label',{staticClass:"vfl-label",class:_vm.classObject,attrs:{"for":_vm.inputId}},[_vm._v("\n    "+_vm._s(_vm.floatLabel)+"\n  ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }